export default __webpack_public_path__ + "static/media/q19_01.914f1276.png";